/**
 * BriqueChart에서 사용하는 Const
 *   - Tooltip Mode List
 *   - Legend 위치 List
 */

/**
   * 툴팁 모드 리스트, 첫번째 것이 Default이다.
   */
export const BRIQUECHART_TOOLTIP_MODES = ['hover', 'click', 'none']

/**
   * 범례위치 리스트 및 및 위치에 따른 Layout
   */
export const BRIQUECHART_LEGEND_POSITIONS = [
  {
    val: 'bottom',
    layout: {
      showlegend: true,
      legend: {
        x: 0.5,
        y: 0, // 적용하는 부분에서 계산에 의해 하고 있음
        traceorder: 'normal',
        font: {
          family: 'sans-serif',
          size: 12
          // color: '#000'
        },
        // bgcolor: '#E2E2E2',
        // bordercolor: '#FFFFFF',
        // borderwidth: 2,
        orientation: 'h',
        xanchor: 'center',
        yanchor: 'top'
      }
    }
  },
  {
    val: 'right',
    layout: {
      showlegend: true,
      legend: {
        x: 1,
        y: 0.99,
        traceorder: 'normal',
        font: {
          family: 'sans-serif',
          size: 12
          // color: '#000'
        },
        // bgcolor: '#E2E2E2',
        // bordercolor: '#FFFFFF',
        // borderwidth: 2,
        orientation: 'v',
        xanchor: 'left',
        yanchor: 'top'
      }
    }
  },
  // {
  //   val: 'left', // 첫번째 것이 Default이다.
  //   layout: {
  //     showlegend: true,
  //     legend: {
  //       x: 0, // 적용하는 부분에서 계산에 의해 하고 있음
  //       y: 0.99,
  //       traceorder: 'normal',
  //       font: {
  //         family: 'sans-serif',
  //         size: 12,
  //         color: '#000'
  //       },
  //       // bgcolor: '#E2E2E2',
  //       // bordercolor: '#FFFFFF',
  //       // borderwidth: 2,
  //       orientation: 'v',
  //       xanchor: 'right',
  //       yanchor: 'top'
  //     }
  //   }
  // },
  // {
  //   val: 'top',
  //   layout: {
  //     showlegend: true,
  //     legend: {
  //       x: 0.5,
  //       y: 1,
  //       traceorder: 'normal',
  //       font: {
  //         family: 'sans-serif',
  //         size: 12,
  //         color: '#000'
  //       },
  //       // bgcolor: '#E2E2E2',
  //       // bordercolor: '#FFFFFF',
  //       // borderwidth: 2,
  //       orientation: 'h',
  //       xanchor: 'center',
  //       yanchor: 'bottom'
  //     }
  //   }
  // },
  {
    val: 'none',
    layout: {
      showlegend: false
    }
  }
]
